module.exports = __webpack_public_path__ + "media/images/shared/muevo_logo_with_text-0e94b0d09f196675c3af59b2efda0897.png";